import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import prettyJoiner from './pretty-joiner'
import PrettyId, {
	handleInvalidValuesProperty
} from './pretty-id'

const PrettyAncestor = function(filter) {
	let labels = []
	let meta = filter.metadata || {}
	let validNodeIds = _.difference(filter.values, filter.invalidValues)
	let validAncestorIds = _.difference(filter.ancestorValues, filter.invalidValues)
	filter.valid = true

	//find the labels for all the valid values
	_.each(validAncestorIds, function (id) {
		var label = _.result(meta[id], 'label')
		if (label) {
			labels.push(i18n.get('admin.groupsByOrganization.viewOrgWithDescendants', label))
		}
	})
	_.each(validNodeIds, function (id) {
		var label = _.result(meta[id], 'label')
		if (label) {
			labels.push(label)
		}
	})

	//handle no references
	PrettyId.handleEmptyReference(filter, labels, () => {
		return labels.length == 0 && ((validNodeIds.length == 0 && validAncestorIds.length == 0) || meta.invalid)
	})

	handleInvalidValuesProperty(filter, labels)

	return i18n.get('report.filter.pretty.multichoice', prettyJoiner(labels))
}

export default PrettyAncestor

PrettyAncestor.__filename__ = 'reports/common/filter/pretty-ancestor.js'
